import React from "react";
import AffiliateDashboard from "../components/AffiliateDashboard";

export default function AffiliateDashboardPage() {
  return <AffiliateDashboard />;
}
